import { useEffect } from "react";
import usePagination from "./usePagination";
import { useQuery } from "@apollo/client";
import { GET_SOS } from "graphql/queries/sos";
import { ISos, ISosIndexParams } from "models/Sos";

const useSos = ({
    page: externalPage,
    pageSize: externalPageSize,
    orderBy = "desc",
}: ISosIndexParams) => {

    const hookSos = usePagination<ISos>({
        page: externalPage,
        pageSize: externalPageSize,
        sortOrder: orderBy as "desc" | "asc"
    });
    const { page, pageSize } = hookSos;

    const { data, loading } = useQuery(GET_SOS(page, pageSize, orderBy as "desc" | "asc"), {
        // pollInterval: 1000*60, //Actualiza cada minuto
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (loading) {
            hookSos.loadingStart();
        } else {
            hookSos.loadingEnd();
        }

        if (data) {
            console.log("🚀 ~ useSos ~ data:", data)
            const { its_sos: dataSosStatuses, its_sos_aggregate } = data;
            const { count: totalItems } = its_sos_aggregate.aggregate;
            hookSos.setData(dataSosStatuses);
            hookSos.setTotalItems(totalItems);
        }
    }, [data, loading]);

    return hookSos;
};

export default useSos;
